import { render, staticRenderFns } from "./ChannelPartnerForm.vue?vue&type=template&id=c997db96&"
import script from "./ChannelPartnerForm.vue?vue&type=script&lang=js&"
export * from "./ChannelPartnerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports